"use client";

import NavSearchTrigger from "@/components/nav/NavSearchTrigger";
import { NAV_RAIL_WIDTH } from "@/components/nav/nav-styles";
import { cn } from "@/lib/utils";

/**
 * Search, first under the studio band and above Home. With the panel open it
 * is a field across the rail and the panel; with the panel hidden, the coral
 * tile centred on the rail. While search is `open` the row is the same field
 * turned into the input, with a back arrow where its icon was: nothing moves
 * and there is no second tile. The input itself belongs to the pane's
 * `Command` and is rendered into `inputSlotRef` (a callback ref SideNav
 * hands the pane), so arrow keys and Enter still drive the list under it.
 * `buttonRef` reaches the trigger, for the shortcut tour and for focus to
 * return to when the search is dismissed.
 */
export default function NavSearchRow({
  wide,
  open,
  buttonRef,
  inputSlotRef,
  onOpen,
}) {
  return (
    <div
      className={cn(
        "flex shrink-0",
        wide ? "px-3 pb-1" : cn("justify-center px-2", NAV_RAIL_WIDTH),
      )}
    >
      {!open && (
        <NavSearchTrigger
          wide={wide}
          buttonRef={buttonRef}
          onClick={onOpen}
          tooltipSide={wide ? "bottom" : "right"}
        />
      )}
      {/* Always mounted so the pane has somewhere to render the input before
          the search opens; shown only while it is open. */}
      <div
        ref={inputSlotRef}
        className={cn("min-w-0 flex-1", !open && "hidden")}
      />
    </div>
  );
}
